// extracted by mini-css-extract-plugin
export default {"root":"ExcludeProfilesButton_root__hqP+r","button":"ExcludeProfilesButton_button__MR2S6","questionMark":"ExcludeProfilesButton_questionMark__uru8R"};